import React from 'react'
import styles from './styles.module.scss'

interface IProps {
  newVacationDays: number
  oldVacationDays: number
}

const Vacation: React.FC<IProps> = ({ newVacationDays, oldVacationDays }: IProps) => {
  return (
    <div className={styles.vacationCard}>
      <div className={styles.vacationTitle}>Your vacation days</div>
      <div className={styles.vacationStats}>
        <div className={styles.vacationStat}>
          <span className={styles.vacationLabel}>This year</span>
          <span className={styles.vacationValue}>{newVacationDays}</span>
        </div>
        <div className={styles.vacationStat}>
          <span className={styles.vacationLabel}>Carried over</span>
          <span className={styles.vacationValue}>{oldVacationDays}</span>
        </div>
        <div className={`${styles.vacationStat} ${styles.vacationTotal}`}>
          <span className={styles.vacationLabel}>Available</span>
          <span className={styles.vacationValue}>{newVacationDays + oldVacationDays}</span>
        </div>
      </div>
    </div>
  )
}

export default Vacation
